import { Component, ViewContainerRef } from "@angular/core"
import { NavigationService } from "./shared/services/navigation.service"

@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    standalone: false
})
export class AppComponent {
  constructor(
    private navigationService: NavigationService,
    public vcRef: ViewContainerRef
  ) {}
}
